import { useQuery } from "@tanstack/react-query";
import { getTransactionFeesUserPartyPublicID } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const TRANSACTIONS_FEES_PARTY_ID_QUERY_KEY = "TRANSACTIONS_FEES_PARTY_ID";

export const getTransactionsFeesPartyIDQueryKey = (
  partyPublicID: string,
  dateFrom?: string | null,
  dateTo?: string | null,
) => [TRANSACTIONS_FEES_PARTY_ID_QUERY_KEY, partyPublicID, dateFrom, dateTo];

export const useTransactionsFeesPartyID = (
  partyPublicID: string,
  dateFrom?: string | null,
  dateTo?: string | null,
) =>
  useQuery({
    queryKey: getTransactionsFeesPartyIDQueryKey(
      partyPublicID,
      dateFrom,
      dateTo,
    ),
    queryFn: processResponseWithApiProblemDetails(() =>
      getTransactionFeesUserPartyPublicID(partyPublicID, dateFrom, dateTo),
    ),
  });
